import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import Loader from "../../general/Loader";
import { formatCurrency } from "../../../utils/helpers";

class Nominas extends Component {
    state = {
        pagos: [],
        loading: true
    };
    componentDidMount() {
        this.getPagos();
    }
    getPagos = async (url = null) => {
        const id = this.props.empleado.id;
        url = url ? url : `empleados/${id}/pagos`;
        const pagos = await this.props.request(url);

        if (pagos.success) {
            this.setState({
                pagos: pagos.data,
                loading: false
            });
        }
    };
    render() {
        const { pagos, loading } = this.state;

        if (loading === 0) {
            return <Loader />;
        }
        return (
            <div>
                <h3>Historial de Pagos</h3>
                <table className='table tickets-table'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Toneladas</th>
                            <th>Sueldo Fijo</th>
                            <th>Sueldo Bruto</th>
                            <th>Descuentos</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pagos.map((pago, index) => (
                            <tr key={index}>
                                <td>{pago.fecha}</td>
                                <td>{pago.toneladas}</td>
                                <td>{formatCurrency(pago.sueldoFijo)}</td>
                                <td>{formatCurrency(pago.sueldoBruto)}</td>
                                <td>{formatCurrency(pago.descuentos)}</td>
                                <td>{formatCurrency(pago.total)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default withRequest(Nominas);
